import styled from 'styled-components';
import { ContentSection } from '../CompensationManagement/CompensationManagement.styles';

/* ════════════════════════════════════════════════════════════════════════════
   CONTENT SECTION — edge-to-edge so the tabs/table span the full page width
   ════════════════════════════════════════════════════════════════════════════ */

export const JdArchiveContentSectionStyled = styled(ContentSection)`
  padding: 0;
`;

/* ════════════════════════════════════════════════════════════════════════════
   INITIAL LOAD SPINNER
   ════════════════════════════════════════════════════════════════════════════ */

export const JdArchiveLoaderStyled = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
`;

/* ════════════════════════════════════════════════════════════════════════════
   TABLE — sticky pagination pinned to the bottom of the scrollable area
   ════════════════════════════════════════════════════════════════════════════ */

export const JdArchiveSectionStyled = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  position: relative;
`;

export const JdArchiveTableWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  .ant-table-thead > tr > th {
    white-space: nowrap;
  }

  .ant-table-pagination {
    position: sticky;
    bottom: 0;
    background: ${({ theme }) => theme.colors.white};
    padding: 12px 16px;
    margin: 0 !important;
    border-top: 1px solid ${({ theme }) => theme.colors.borderLight};
  }
`;

/* ════════════════════════════════════════════════════════════════════════════
   ROW ACTION MENU — same shape as ManageGroupsModal's kebab menu
   ════════════════════════════════════════════════════════════════════════════ */

export const ActionsCellStyled = styled.div`
  display: flex;
  justify-content: center;
`;

/* ════════════════════════════════════════════════════════════════════════════
   ARCHIVE CONFIRM MODAL
   ════════════════════════════════════════════════════════════════════════════ */

export const ConfirmLabelStyled = styled.div`
  margin-top: 16px;
  margin-bottom: 6px;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.tertiary};

  strong {
    color: ${({ theme }) => theme.colors.dark};
  }
`;

export const ArchiveWarningBoxStyled = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.warningBg};
  color: ${({ theme }) => theme.colors.dark};
  font-size: 13px;

  .anticon {
    color: ${({ theme }) => theme.colors.warningMessage};
    margin-top: 2px;
  }
`;

/* ════════════════════════════════════════════════════════════════════════════
   HEADER SEARCH — same control and placement as the Jobs Library search
   ════════════════════════════════════════════════════════════════════════════ */

export const JdArchiveSearchWrapperStyled = styled.div`
  min-width: 320px;

  .ant-select {
    width: 100%;
  }

  /*
   * Ant Design places both allowClear (×) and suffixIcon in the same right-side
   * slot. When suffixIcon is an SbButton the × renders on top of it.
   * Offsetting .ant-select-clear pushes it left of the button so both are visible.
   */
  .ant-select-clear {
    right: 44px;
  }
`;
